<template>
  <div>
    <careers-list-filters
        v-if="includeControls"
        :search-box="false"
        :filter-categories="filterCategories"
        :on-value-chosen="onValueChosen"
        :update-search-string="updateSearchString"
        :items-present="items.length"
        justify="left"></careers-list-filters>

    <pager
      v-if="includeControls"
      :items-length="total_count" 
      :items-per-page="itemsPerPage"
      :active-index="activeIndex"
      :page-options-to-show="pageOptionsToShow"
      @page-to="pageTo"
      className="pager_borderBottom"
      >
    </pager>

    <transition name="v-fade" mode="out-in">
        <div v-if="!dataIsLoaded && !items.length" class="m-positionRelative">
            <div class="loading"></div>
        </div>
    </transition>
    <transition name="v-fade">
      <div v-if="dataIsLoaded">
        <slot
          name="dynamic-list-results"
          :items="items"
          :read-more-copy="readMoreCopy"
          :block-columns-sm="blockColumnsSm"
          :block-columns-md="blockColumnsMd"
          :block-columns-lg="blockColumnsLg"
        ></slot>
      </div>
    </transition>
    <pager
      v-if="includeControls"
      :items-length="total_count" 
      :items-per-page="itemsPerPage"
      :active-index="activeIndex"
      :page-options-to-show="pageOptionsToShow"
      @page-to="pageTo"
      className="pager_borderTop"
      >
    </pager>

  </div>
</template>

<script>
import Pager from "./Pager.vue";
import CareersListFilters from "../templates/CareersListFilters.vue";

import DynamicSearchService from "../../service/DynamicSearchService.js";
import { camelize } from "../../utilities/camelize.js";
import { debounce } from "../../utilities/debounce.js";
import { jsonToQueryString } from "../../utilities/jsonToQueryString";
import { getParams, applySpaces } from "../../utilities/getParams";

export default {
  components: {
    Pager,
    CareersListFilters
  },
  props: {
    initialFilters: Array,
    tableHeaders: Array,
    blockColumnsSm: {
      type: Number,
      default: 1
    },
    blockColumnsMd: {
      type: Number,
      default: 1
    },
    blockColumnsLg: {
      type: Number,
      default: 1
    },
    itemsPerPage: {
      type: Number
    },
    pageOptionsToShow: {
      type: Number,
      default: 9
    },
    includeControls: {
      type: Boolean,
      default: true
    },
    readMoreCopy: {
      type: String,
      default: "Read more"
    },
    endpoint: {
      type: String
    },
	preLoadFilterValue: {
	  type: String
	}
  },
  data() {
    return {
      filterCategories: null,
      items: [],
      queryObject: {
        q: "",
        filterValues: {}
      },
      activeIndex: 0,
      total_count: 0,
      dataIsLoaded: false
    };
  },
  //   computed: {},
  async created() {
    // initialize data structure for the view's usage
    this._initializeFilterCategoryOptions();

    // initialize data structure for api usage
    this._setInitialCategories(this.initialFilters);

    /* Prepopulates forms if query string values are present */
    this._extractQueryStringParams();

    // perform initial fetch
    await this.getItems();
  },
  methods: {
    _initializeFilterCategoryOptions() {
      this.filterCategories = this.initialFilters.map(item => {
        item.options = [];
        return item;
      });
    },

    _setInitialCategories() {
      /* Establishing empty filter values based on initial filters
      and storing them in queryObject.filterValues so we can use them in 
      our initial this.getItems() request which will populate select filters 
      with options */
      for (let i = 0; i < this.filterCategories.length; i++) {
        let key = this.filterCategories[i].name;
        // setting with empty string so the API will provide us with all options available
        this._setFilterValue(key, this.filterCategories[i].initialValue||"");
      }
    },
    _extractQueryStringParams() {
      const queryParams = getParams(window.location);
      let filterCategories = this.filterCategories;
      if (
        Object.keys(queryParams).length === 0 &&
        queryParams.constructor === Object
      ) {
        return false; //No query values to prepopluate search with
      }

      for (const key in queryParams) {
        const value = queryParams[key];
        if (key === 'tag') 
          continue;
        this._setFilterValue(key, value);
      }

      return;
    },
    /**
     * Set filter value for API data
     *
     * @param {string} key
     * @param {string} value
     */
    _setFilterValue(key, value) {
      this.queryObject.filterValues[key] = value;
    },

    onValueChosen(key, value) {
      this.activeIndex = 0;
      this._setFilterValue(key, value);
      this.getItems();
      // this.pageTo(0);
    },

    updateSearchString: debounce(function(value) {
      this.activeIndex = 0;
      this.queryObject.q = value;
      this.getItems();
    }, 500),

    pageTo(newIndex) {
      this.activeIndex = newIndex;
      this.getItems();
    },
    buildQueryObject() {
      return {};
    },

    async getItems() {
      const queryObject = this.buildQueryObject();
      this.dataIsLoaded = false;

      let response = await DynamicSearchService.getResults(
        this.endpoint,
        this.queryObject,
        this.activeIndex,
        this.itemsPerPage,
        this.preLoadFilterValue
      );
      
      this._processResponse(response);
      this.dataIsLoaded = true;
    },

    _processResponse(response) {
      // copy filters
      this._copyOptionsToCategories(response.filterGroupItems);

      // copy items
      this.items = response.results;
      //   console.log('>>>> items: ', this.items);

      this.total_count = response.totalItems;
    },

    _copyOptionsToCategories(optionsByCategory) {
      for (let i = 0; i < this.filterCategories.length; i++) {
        const category = this.filterCategories[i];

        // find the options for this category and set them
        category.options = optionsByCategory[category.name];
      }
    }
  }
};
</script>

<style lang="scss">
</style>

